import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../types/app.types';
import {ItemModifier} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class ModifierModel {
  public quantity?: number;
  public label: string;
  public details?: string;
  public price?: PriceModel;

  constructor(params: ModifierModel) {
    this.quantity = params?.quantity;
    this.label = params?.label;
    this.details = params?.details;
    this.price = params?.price;
  }

  public static fromCartV1(modifier: ItemModifier, modelContext: ModelContext): ModifierModel {
    return new ModifierModel({
      quantity: modifier.quantity ?? undefined,
      label: modifier.label?.translated ?? modifier.label?.original ?? /* istanbul ignore next */ '',
      details: modifier.details?.translated ?? modifier.details?.original ?? /* istanbul ignore next */ undefined,
      price: modifier.price ? PriceModel.fromCartV1(modifier.price, modelContext) : undefined,
    });
  }

  public static fromCartV2(modifier: ItemModifier, modelContext: ModelContext): ModifierModel {
    return new ModifierModel({
      quantity: modifier.quantity ?? undefined,
      label: modifier.label?.translated ?? modifier.label?.original ?? /* istanbul ignore next */ '',
      details: modifier.details?.translated ?? modifier.details?.original ?? /* istanbul ignore next */ undefined,
      price: modifier.price ? PriceModel.fromCartV2(modifier.price, modelContext) : undefined,
    });
  }
}
